<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { commercialEmail, mailtoUrl, supportEmail } from '@/configs';
import PhoneQuotaReachedNotice from './PhoneQuotaReachedNotice.vue';

const props = defineProps<{ used: number; limit: number | null; full: boolean }>();
const { t } = useI18n();

const label = computed(() =>
    props.limit === null
        ? t('whatsappMeta.quota.unlimited', { used: props.used })
        : t('whatsappMeta.quota.limited', { used: props.used, limit: props.limit }),
);
const requestIncreaseUrl = computed(() =>
    mailtoUrl(
        commercialEmail,
        supportEmail,
        t('whatsappMeta.quota.requestSubject'),
        t('whatsappMeta.quota.requestBody', { used: props.used, limit: props.limit ?? '-' }),
    ),
);
</script>

<template>
    <UiSettingsSection
        :title="t('whatsappMeta.quota.title')"
        :footer="t('whatsappMeta.quota.footer')"
    >
        <UiSettingsRow :title="t('whatsappMeta.quota.rowTitle')">
            <template #description>
                <p class="text-xs leading-relaxed text-gray-500">
                    {{ t('whatsappMeta.quota.rowDescription') }}
                    <a class="text-primary font-medium underline" :href="requestIncreaseUrl">
                        {{ t('whatsappMeta.quota.requestIncrease') }}
                    </a>
                </p>
            </template>
            <template #action>
                <UiBadge variant="gray-100" text-variant="gray-700" size="sm">
                    {{ label }}
                </UiBadge>
            </template>
        </UiSettingsRow>
        <PhoneQuotaReachedNotice :full="full" :limit="limit" />
    </UiSettingsSection>
</template>
